import {
  getOfflineStatusCopy,
  OfflineBanner,
} from '@affine/core/components/offline-status';
import { useI18n } from '@affine/i18n';

export const useSettingsOfflineIncompleteLabel = () => {
  const t = useI18n();

  return getOfflineStatusCopy(t, 'settings-online-only');
};

export const SettingsOfflineHeaderAction = ({ show }: { show: boolean }) => {
  const label = useSettingsOfflineIncompleteLabel();

  if (!show) return null;

  return (
    <OfflineBanner
      isOnline={false}
      label={label}
      variant="warning"
      style={{
        margin: 0,
        maxWidth: 280,
        padding: '4px 8px',
      }}
    />
  );
};
